import CalCountAiLogoSvg from "@components/CalCountAiLogoSvg"
import Layout from "@components/Layout"
import PageHeading from "@components/PageHeading"
import SubscriptionDialog from "@components/SubscriptionDialog"
import { useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useLoaderData } from "react-router-dom"
import { GetSubscriptionLoaderData } from "src/loaders/getSubscriptionLoader"
import GooglePlayAndAppStoreBadgeLinks from "../../components/GooglePlayAndAppStoreBadgeLinks"

export default function SubscriptionPage() {
  const { revenueCatSubscriptions, userEmail } =
    useLoaderData() as GetSubscriptionLoaderData

  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false)

  const { t } = useTranslation()

  return (
    <>
      <Layout>
        <div className="flex shrink-0 items-center justify-between">
          <CalCountAiLogoSvg />

          {revenueCatSubscriptions.length > 0 && (
            <button
              className="cursor-pointer p-4 text-base font-semibold underline hover:opacity-80"
              onClick={() => setOpenSubscriptionDialog(true)}
              type="button"
            >
              {t("pages.account.subscription.subscriptionInfo")}
            </button>
          )}
        </div>

        <div className="my-8 flex grow flex-col justify-center space-y-8 sm:space-y-16">
          <PageHeading>{t("pages.account.subscription.heading")}</PageHeading>

          <p className="text-center text-xl font-semibold underline">
            {t("pages.account.subscription.noNewSubscription")}
          </p>

          <p className="text-center whitespace-pre-wrap">
            <Trans
              components={{
                bold: <span className="font-semibold break-all" />,
              }}
              values={{ email: userEmail }}
              i18nKey="pages.account.subscription.signIntoApp"
            />
          </p>

          <GooglePlayAndAppStoreBadgeLinks />
        </div>
      </Layout>

      {openSubscriptionDialog && revenueCatSubscriptions.length > 0 && (
        <SubscriptionDialog
          onClose={() => setOpenSubscriptionDialog(false)}
          open={openSubscriptionDialog}
          subscriptions={revenueCatSubscriptions}
        />
      )}
    </>
  )
}
